import deepmerge from 'deepmerge';
import general from './general';

export default deepmerge.all([general]);
